import React from 'react';
import { styled } from 'linaria/react';

import ProductRowImported from '../StartPage/Content/ProductRow';

const Wrapper = styled('div')`
  margin-bottom: 2rem;
`;

const ProductRow = ({ products }) => {
  const productsList = products?.split(',');
  return (
    <Wrapper>
      <ProductRowImported products={productsList} />
    </Wrapper>
  );
};
export default ProductRow;
